import { SHARE_TYPE } from "@constants";

export function formatShareName(input) {
  switch (input) {
    case SHARE_TYPE.NORMAL:
      return 'Normal Share';
    case SHARE_TYPE.REGISTER:
      return 'Register Share';
    case SHARE_TYPE.TOPUP:
      return 'Top Up Share';
    case SHARE_TYPE.POCKET_MONEY:
      return 'Pocket Money Share';
    case SHARE_TYPE.SPIN:
      return 'Spin Share';
    case SHARE_TYPE.WITHDRAW:
      return 'Withdraw Share';
    default:
      return input;
  }
}